export const breakPoint = {
    mobile: "425px",
    tablet: "768px",
    laptop: "1440px",
    desktop: "2560px",
};

// export const breakPoint = {
//     mobile: `(min-width: ${size.mobile})`,
//     tablet: `(min-width: ${size.tablet})`,
//     laptop: `(min-width: ${size.laptop})`,
//     desktop: `(min-width: ${size.desktop})`,
// };
